export const apificate = state => {
  return {
    id: state.id,
    vendor: state.vendor,
    payer: state.payer,
    description: state.description,
    totalAmount: parseFloat(state.totalAmount),
    unit: state.unit,
    count: parseFloat(state.count)
  }
}
